import React from "react";
import { RadixModal } from "../primitives/RadixModal";
import { useCreditPaymentContext } from "./CreditPaymentContext";
export var PaymentErrorNotice = function (_a) {
    var error = _a.error, onAcknowledge = _a.onAcknowledge, onDismiss = _a.onDismiss;
    var clearPaymentError = useCreditPaymentContext().clearPaymentError;
    if (!error) {
        return null;
    }
    return (React.createElement(RadixModal, { open: Boolean(error), onOpenChange: function (open) {
            if (!open) {
                if (onDismiss) {
                    onDismiss();
                }
                else {
                    clearPaymentError();
                }
                onAcknowledge === null || onAcknowledge === void 0 ? void 0 : onAcknowledge();
            }
        }, title: "Payment Error", description: error.defaultMessage, status: "error" }));
};
